module.exports = "/dist/assets/images/zoom_in.svg";